import { FC } from 'react';
import { FormState, UseFormRegister } from 'react-hook-form';

import { useRegistrationStore } from 'page/CustomerPage/hooks';
import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { InputModalView } from 'page/CustomerPage/components/RegistrationModal/InputModalView';
import { Channel } from 'types/customer';

type Props = {
  watchChannel: Channel;
  watchEnableVerticalPodAutoScaler: boolean;
  formState: FormState<CustomerFormFields>;
  register: UseFormRegister<CustomerFormFields>;
  handleClose: () => void;
  handleClickGoConfirmation: () => void;
};

export const InputModal: FC<Props> = ({
  watchChannel,
  watchEnableVerticalPodAutoScaler,
  formState,
  register,
  handleClose,
  handleClickGoConfirmation,
}) => {
  const { isOpenInputModal } = useRegistrationStore();

  /** 確認ボタンの非活性状態 */
  const isButtonDisabled = !formState.isValid;

  return (
    <>
      {/* 入力モーダル */}
      <InputModalView
        watchChannel={watchChannel}
        watchEnableVerticalPodAutoScaler={watchEnableVerticalPodAutoScaler}
        formState={formState}
        isOpen={isOpenInputModal}
        isButtonDisabled={isButtonDisabled}
        register={register}
        handleClose={handleClose}
        handleClickGoConfirmation={handleClickGoConfirmation}
      />
    </>
  );
};
